<script setup lang="ts">
import { LoadStatus } from "@/models/frontend-only/LoadStatus";

const store = useSongStore();
const shown = computed(() => {
  if (store.status !== LoadStatus.Ready) {
    return false;
  }

  if (!store.song) {
    return false;
  }

  const products = store.song.products;

  return (
    !products.chords.exists &&
    !products.lyrics.exists &&
    !products.vocal.exists &&
    !products.lead.exists
  );
});
</script>

<template>
  <section v-if="shown">
    <SectionTitle>{{ $t("SV.LIT_NoAvailableContent") }}</SectionTitle>
    <div>
      <p>
        <i18n-t
          keypath="SV.MES_NoLyrics"
          tag="span"
          scope="global"
        >
          <template v-slot:license>
            <a
              href="https://ccli.com/copyright-license"
              target="_blank"
              >{{ $t("SV.LIT_CCLIChurchCopyrightLicense")
              }}<sup class="trademark">&reg;</sup>
              <FAIcon class="fa-light fa-external-link" />
            </a>
          </template>
        </i18n-t>
      </p>
    </div>
  </section>
</template>

<style scoped lang="postcss"></style>
